import { render, staticRenderFns } from "./ShortClosedAnswer.vue?vue&type=template&id=66353876&scoped=true&"
import script from "./ShortClosedAnswer.vue?vue&type=script&lang=ts&"
export * from "./ShortClosedAnswer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66353876",
  null
  
)

export default component.exports